// Selo fixo de partidas grátis (item 59.1), só para quem está no Grátis: as duas fichas do dia, "1 de 2 grátis hoje",
// o bônus guardado e o botão ASSINAR. Sem partidas, "Acabaram as grátis de hoje" e a linha de quando voltam. Tocar no
// selo (fora do botão) abre a tela Limite. Embaixo, uma vez por tela, a linha "Chame um amigo: +5 partidas para você".
// A casca (App.tsx) diz o plano; o selo aparece no topo das 4 telas com menu e no lobby da sala.
import { createContext, useContext, useEffect, useState } from 'react';
import { BONUS_POR_INDICACAO, type Plano } from '@truco6/planos';
import type { SituacaoLimite } from './api.ts';
import { avisoDoLimiteVisto, diariasRestantes, noGratis, semPartidas, tirarPiscarSelo, toqueEmAssinar, toqueEmIndique, useLimite } from './limite.ts';
import { ir } from './rotas.ts';

// O plano da conta da aba, que a casca põe à disposição das telas. null: sem conta ou sem perfil ainda.
export const PlanoDaCasca = createContext<Plano | null>(null);

export const abrirPlanosNoBronze = () => ir({ tela: 'planos', plano: 'bronze', ciclo: 'mensal' });

export function SeloGratis({ limite, indique = 'curta' }: { limite: SituacaoLimite; indique?: 'curta' | 'longa' | false }) {
  const sem = semPartidas(limite), diarias = diariasRestantes(limite), total = limite.limite ?? 0;
  useEffect(() => { if (sem) avisoDoLimiteVisto('selo'); }, [sem]);
  // Saiu da mesa com 1 sobrando: a borda pisca em laranja por 3 s, uma vez (com movimento reduzido, só a cor muda).
  const [piscar, setPiscar] = useState(false);
  useEffect(() => { if (tirarPiscarSelo()) setPiscar(true); }, []);
  useEffect(() => {
    if (!piscar) return;
    const t = setTimeout(() => setPiscar(false), 3000);
    return () => clearTimeout(t);
  }, [piscar]);
  return (
    <div className="selo-gratis-bloco">
      <section className={'selo-gratis' + (sem ? ' sem' : '') + (piscar ? ' piscar' : '')} aria-label="Partidas grátis de hoje">
        <button className="selo-info" onClick={() => ir({ tela: 'limite' })}
          aria-label={sem ? 'Acabaram as grátis de hoje. Ver o que fazer' : `${diarias} de ${total} grátis hoje${limite.bonus ? `, mais ${limite.bonus} de bônus` : ''}. Ver detalhes`}>
          <span className="fichas" aria-hidden="true">
            {Array.from({ length: total }, (_, i) => <i key={i} className={i < diarias ? 'cheia' : 'gasta'} />)}
          </span>
          <span className="selo-texto">
            {sem ? 'Acabaram as grátis de hoje' : <><b>{diarias} de {total}</b> grátis hoje</>}
            {limite.bonus > 0 && <span className="selo-bonus">+{limite.bonus} bônus</span>}
          </span>
        </button>
        <button className="selo-assinar" onClick={() => { toqueEmAssinar('selo'); abrirPlanosNoBronze(); }}>ASSINAR</button>
        {sem && <p className="selo-volta">Volta à meia-noite. Chame um amigo e ganhe +{BONUS_POR_INDICACAO}.</p>}
      </section>
      {indique && (
        <button className="linha-indique" onClick={() => { toqueEmIndique('selo'); ir({ tela: 'indique' }); }}>
          <span aria-hidden="true">🎁</span>
          {indique === 'longa'
            ? `Chame um amigo: +${BONUS_POR_INDICACAO} partidas para você. Ele ganha a conta, você ganha as partidas.`
            : `Chame um amigo: +${BONUS_POR_INDICACAO} partidas para você`}
        </button>
      )}
    </div>
  );
}

// Quem está no Grátis e não tem mais partidas hoje: criar sala, entrar com código e sentar levam à tela Limite.
export function useSemPartidas(): boolean {
  const plano = useContext(PlanoDaCasca), limite = useLimite();
  return !!plano && noGratis(plano, limite) && semPartidas(limite);
}

// O selo no lugar dele: só para quem está no Grátis, com o limite já lido. Assinante não vê nada.
export function SeloNoTopo({ indique = 'curta' }: { indique?: 'curta' | 'longa' | false }) {
  const plano = useContext(PlanoDaCasca), limite = useLimite();
  if (!plano || !limite || !noGratis(plano, limite)) return null;
  return <SeloGratis limite={limite} indique={indique} />;
}
